<template>
	<div style="min-height: 75vh">

		<div class="offers-list__container" v-if="!loadingOffers">
			<ExpiredOfferTile :id="index" @cardClicked="handleCardClick" v-for="(offer, index) in expiredOffers"
				:key="index" />
		</div>


		<div v-if="loadingOffers" class="offers-list__container">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line,divider,list-item-two-line"
				v-for="n in 20" :key="n" color="var(--v-skeleton-loader-color)"></v-skeleton-loader>
		</div>


		<EmptyList class="mx-auto mt-4" v-if="expiredOffers.length === 0">
			<template v-slot:title>
				Sorry, you don't have any expired offers.
			</template>
		</EmptyList>


		<Pagination 
			:model-value="expiredOfferStatusListPage"
			@update:model-value="(value) => expiredOfferStatusListPage = value"
			:length="expiredOfferStatusListPageLength" 
			:total-visible="totalVisible"
		/>

	</div>
</template>



<script setup>

import { OfferStore } from "@/store/offerStore";
import { computed, onMounted } from "vue";
import EmptyList from "@/components/Common/Empty-List.vue";
import { OfferStatusStore } from "@/store/OfferStatusStore";
import Pagination from "@/components/Common/Pagination.vue";
import ExpiredOfferTile from "@/components/Tiles/Offer/Status/Expired-Offer-Status-Tile.vue";
import { usePagination } from "@/composables/usePagination";

const emit = defineEmits(["cardClicked"]);
const offerStatusStore = OfferStatusStore();

const offerStore = OfferStore();
const loadingOffers = computed(() => offerStore.loadingOffers);

const expiredOffers = computed(() => offerStatusStore.expiredOffers);

// Use the pagination composable to handle pagination logic
const { pageNumber: expiredOfferStatusListPage, pageLength: expiredOfferStatusListPageLength, totalVisible } = usePagination({
  store: offerStatusStore,
  getTotalPages: (store) => store.expiredOffersPaging.totalPages,
  getCurrentPage: (store) => store.expiredOffersPaging.page,
  setPage: (store, page) => store.setExpiredOffersPage(page),
  fetchData: async (store) => await store.getAllMyOffers()
});

onMounted(() => {
  offerStatusStore.getAllMyOffers();
});

const handleCardClick = () => {
  emit("cardClicked");
};

</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
.offers-list__container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

</style>
